<template>
  <div />
</template>
<script setup lang="ts">
import { navigateTo } from 'nuxt/app'

definePageMeta({
  middleware: () => navigateTo('/404', { replace: true })
})
</script>
